import styled from 'styled-components';
import breakpoints from 'Helpers/BreakpointHelper';
import media from 'styled-media-query';

export const ImageWrapper = styled.div`
	div {
		height: 85px !important;
	}
	img {
		max-height: 85px;
	}
`;
